import React from 'react';
import {Select} from 'formik-antd';
import {useMasterAccounts} from '../hooks/useMasterAccounts';

type Props = {
  name: string;
};

const SelectMasterAccounts: React.FC<Props> = ({name}) => {
  const {selectOptions, loading} = useMasterAccounts();

  return (
    <Select
      name={name}
      style={{width: '100%'}}
      allowClear
      showSearch
      disabled={loading}
      loading={loading}
      optionFilterProp="children"
      placeholder="Select master account">
      {selectOptions.map((option: {label: string; value: string}) => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectMasterAccounts;
